<template>
  <div class="menu_footer">
    <div class="icon_box" @click="download">
      <i class="iconfont icondownload"></i>
      <span>数据下载</span>
    </div>
    <div class="icon_box" @click="showDialog = true">
      <i class="iconfont icondaochu"></i>
      <span>报告导出</span>
    </div>
    <export-dialog
      :visible="showDialog"
      :tree-data="data"
      v-if="showDialog"
      @close="closeModal"
    ></export-dialog>
  </div>
</template>

<script>
import exportDialog from './export-dialog';
import loadingMask from '@/components/loading-mask';
import { getToken } from '@/utils/index';
export default {
  props: ['towerList'],
  data() {
    return {
      showDialog: false
    };
  },
  computed: {
    data() {
      return this.towerList;
    },
    towerInfo() {
      return this.$store.state.WindData.towerObj;
    }
  },
  methods: {
    closeModal() {
      this.showDialog = false;
    },
    download() {
      this.aswitch = loadingMask({ mask: true });
      let key = getToken();
      let { towerId, versionId } = this.towerInfo || {};
      if (!towerId) {
        return this.$message.error('测风塔id为空！请选择测风塔。');
      }
      if (!versionId) {
        return this.$message.error('测风数据版本id为空！');
      }
      let paramsObj = {
        apiKey: key,
        towerId,
        versionId
      };
      let preStr = process.env.VUE_APP_API_HOST_WINDDATA;
      let downLoadApi = '/winddata/WindAnalyze/downloadHistoryFile';
      let paramsStr = Object.keys(paramsObj).reduce((acc, item) => {
        acc += (acc ? '&' : '?') + item + '=' + paramsObj[item];
        return acc;
      }, '');
      let url = preStr + downLoadApi + paramsStr;
      window.open(url, '_parent');
      this.aswitch.close();
    }
  },
  components: {
    exportDialog
  }
};
</script>

<style lang="less" scoped>
.menu {
  &_footer {
    position: fixed;
    bottom: 0;
    height: 50px;
    left: 0;
    right: 0;
    background: #28282e;
    z-index: 20;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 230px;
  }
}
.icon_box {
  cursor: pointer;
  &:first-child {
    margin-right: 15px;
  }
  i,
  span {
    font-size: 12px;
    color: #7e7f7f;
  }
}
</style>
